var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#C5D4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9997 38.0002V48.0002L54.6663 51.3335M64.6663 48.0002C64.6663 57.2049 57.2044 64.6668 47.9997 64.6668C38.7949 64.6668 31.333 57.2049 31.333 48.0002C31.333 38.7954 38.7949 31.3335 47.9997 31.3335C57.2044 31.3335 64.6663 38.7954 64.6663 48.0002Z",
    stroke: "#3B6DEA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 80,
    height: 80,
    rx: 40,
    stroke: "#E1E9FC",
    strokeWidth: 14.2857
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi1);
export default __webpack_public_path__ + "static/media/fi1.295ca989be05469dcff52a0aaa4acc42.svg";
export { ForwardRef as ReactComponent };